import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "../store";
import { IErrorSliceType } from "../../types/error.types";

const INITIAL_STATE: IErrorSliceType[] = [];

const errorSlice = createSlice({
  name: "error",
  initialState: INITIAL_STATE,
  reducers: {
    reset: () => {
      return [];
    },
    removeError: (state, action) => {
      return state.filter((error) => error.type !== action.payload.type);
    },
    updateError: (state, action) => {
      const { type, textMessage, visible } = action.payload;
      const existingErrorIndex = state.findIndex((error) => error.type === type);

      if (existingErrorIndex !== -1) {
        return state?.map((error) => {
          if (error.type === type) {
            return {
              ...error,
              textMessage: textMessage !== undefined ? textMessage : error.textMessage,
              visible: visible !== undefined ? visible : error.visible,
            };
          }
          return error;
        });
      } else {
        return [...state, { type, textMessage: textMessage || "", visible: visible || false }];
      }
    },
  },
});

export const selectErrors = (state: RootState) => state.error;

export const selectErrorsByType = (type: string) => (state: RootState) =>
  state.error.find((error) => error.type === type);

export const { reset, removeError, updateError } = errorSlice.actions;
export default errorSlice.reducer;
